import React, { Component, Fragment } from "react";
import { Button, FormGroup, Input, Label, Table } from "reactstrap";

class   ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render() {
    return (
      <Fragment>
        <div>
          <FormGroup>
          <Label htmlFor="old_password">Old Password</Label>
          <Input
            type="password"
            id="old_password"
            placeholder="Enter Old Password"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="new_password">New Password</Label>
          <Input
            type="password"
            id="new_password"
            placeholder="Enter New Password"
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="confirm_password">Confirm New Password</Label>
          <Input
            type="password"
            id="confirm_password"
            placeholder="Re-enter New Password"
          />
        </FormGroup>
        </div>
        <div>
          <Button 
            className="btn mr-1" 
            color="primary">
            Save Changes
          </Button>
          <Button
            className="btn"
            outline
            color="danger">
            Cancel
          </Button>
        </div>
      </Fragment>
    );
  }
}

export default ChangePassword;